export default {
  'pages.setting.menu.title': 'Menu Management',
  'pages.setting.menu.subtitle':
    'Configure menus for headquarters and tenant platforms',
  'pages.setting.menu.searchPlaceholder': 'Search menu name or path',
  // Platform
  'pages.setting.menu.platform.hq': 'Headquarters Platform',
  'pages.setting.menu.platform.tenant': 'Tenant Platform',
  'pages.setting.menu.platform.app': 'App Platform',
  // Table columns
  'pages.setting.menu.column.menuName': 'Menu Name',
  'pages.setting.menu.column.icon': 'Icon',
  'pages.setting.menu.column.path': 'Route',
  'pages.setting.menu.column.menuType': 'Type',
  'pages.setting.menu.column.perms': 'Permission',
  'pages.setting.menu.column.orderNum': 'Sort',
  'pages.setting.menu.column.visible': 'Visible',
  'pages.setting.menu.column.operation': 'Operation',
  // Menu type
  'pages.setting.menu.type.directory': 'Directory',
  'pages.setting.menu.type.menu': 'Menu',
  'pages.setting.menu.type.button': 'Button',
  // Actions
  'pages.setting.menu.add': 'Add Menu',
  // Modal titles
  'pages.setting.menu.modal.addTitle': 'Add Menu',
  'pages.setting.menu.modal.editTitle': 'Edit Menu',
  // Form
  'pages.setting.menu.form.menuName': 'Menu Name',
  'pages.setting.menu.form.menuNamePlaceholder': 'Please enter menu name',
  'pages.setting.menu.form.menuNameRequired': 'Please enter menu name',
  'pages.setting.menu.form.path': 'Menu Path',
  'pages.setting.menu.form.pathPlaceholder': 'Please enter menu path',
  'pages.setting.menu.form.pathRequired': 'Please enter menu path',
  'pages.setting.menu.form.icon': 'Icon',
  'pages.setting.menu.form.iconPlaceholder': 'Please select icon',
  'pages.setting.menu.form.parentId': 'Parent Menu',
  'pages.setting.menu.form.parentIdPlaceholder': 'Please select parent menu',
  'pages.setting.menu.form.menuType': 'Type',
  'pages.setting.menu.form.menuTypePlaceholder': 'Please select type',
  'pages.setting.menu.form.menuTypeRequired': 'Please select type',
  'pages.setting.menu.form.orderNum': 'Sort Order',
  'pages.setting.menu.form.orderNumPlaceholder': 'Please enter sort order',
  'pages.setting.menu.form.perms': 'Permission Code',
  'pages.setting.menu.form.permsPlaceholder': 'e.g.: user:view, tenant:edit',
  'pages.setting.menu.form.permsRequired': 'Please enter permission code',
  'pages.setting.menu.form.visible': 'Visible',
  'pages.setting.menu.form.visibleRequired': 'Please select visibility',
  'pages.setting.menu.form.status': 'Enabled',
  'pages.setting.menu.form.statusRequired': 'Please select enable status',
  // Common options
  'pages.setting.menu.option.yes': 'Yes',
  'pages.setting.menu.option.no': 'No',
  // Messages
  'pages.setting.menu.message.deleteSuccess': 'Deleted successfully',
  'pages.setting.menu.message.addSuccess': 'Added successfully',
  'pages.setting.menu.message.editSuccess': 'Updated successfully',
};
